export default "__VITE_ASSET__BBzfSd57__"